import { formatDistanceToNow, fromUnixTime } from 'date-fns';
import type { Plan } from '../../interface';
import { formatMonthlyPrice } from '../../Plans';
import { CouponExpiry, CouponOffer, PlanOfferContainer } from './styled';

interface Props {
  plan: Plan;
  couponId: string;
  couponRedeemBy: number;
}

export const PlanOffer = ({ plan, couponId, couponRedeemBy }: Props) => {
  return (
    <PlanOfferContainer>
      {plan.amount > 0 && couponId && (
        <>
          <CouponOffer data-cy-id={`${plan.type}-plan-discount`}>
            <span>
              {plan.currencyISO}{' '}
              {formatMonthlyPrice(plan.amount, plan.interval, plan.currencyISO)}
            </span>
          </CouponOffer>
          {couponRedeemBy > 0 && (
            <CouponExpiry>
              Offer expires in{' '}
              {formatDistanceToNow(fromUnixTime(couponRedeemBy / 1000))}
            </CouponExpiry>
          )}
        </>
      )}
    </PlanOfferContainer>
  );
};

export default PlanOffer;
